export default <RouterConfig> {
    scrollBehavior(to, from) {
        if (to.hash !== '') {
            // if target is anchor link, abort
            return;
        }

        if (to.path === from.path) {
            return { el: to.hash?.length ? to.hash : '#layout', top: 0 };
        }

        // Only scroll to top if user hasn't scrolled during the delay
        // or always scroll if scrollY exceeds 800px
        return new Promise((resolve) => {
            let scrolled = false;

            const onScroll = () => {
                if (window.scrollY > 800) {
                    window.removeEventListener('scroll', onScroll);
                    clearTimeout(timeoutId);
                    resolve({ el: to.hash?.length ? to.hash : '#layout', top: 0, behavior: 'instant' });
                } else {
                    scrolled = true;
                    window.removeEventListener('scroll', onScroll);
                    clearTimeout(timeoutId);
                    resolve(false); // Do not scroll
                }
            };

            window.addEventListener('scroll', onScroll, { passive: true });
            const timeoutId = setTimeout(() => {
                window.removeEventListener('scroll', onScroll);
                if (!scrolled || window.scrollY > 800) {
                    resolve({ el: to.hash?.length ? to.hash : '#layout', top: 0, behavior: 'instant' });
                }
            }, 1000);
        });
    }
};